import { useParams, Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { categories } from '../../mocks/categories';
import { products } from '../../mocks/products';

const CategoryPage = () => {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const categoryProducts = products.filter((p) => p.categorySlug === slug);

  if (!category) {
    return (
      <div className="min-h-screen bg-cream">
        <Navbar />
        <section className="pt-32 pb-20 text-center">
          <h1 className="text-4xl font-display font-bold text-navy">Kategori bulunamadı</h1>
          <Link to="/urunler" className="mt-8 inline-flex items-center gap-2 text-coral font-medium cursor-pointer">
            <i className="ri-arrow-left-line"></i> Tüm Kategoriler
          </Link>
        </section>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-cream">
      <Navbar />

      <section className="pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="mb-6">
            <Link
              to="/urunler"
              className="inline-flex items-center gap-2 text-sm text-warmGray hover:text-coral transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-left-line"></i> Tüm Kategoriler
            </Link>
          </div>

          <div className="max-w-4xl mx-auto text-center mb-16">
            <p className="text-sm text-warmGray mb-4">KATEGORİ</p>
            <h1 className="text-5xl md:text-6xl font-display font-bold text-navy mb-6">
              {category.name}
            </h1>
            <p className="text-lg text-warmGray leading-relaxed">
              Anaokulları ve oyun alanları için özel tasarlanmış {category.name.toLowerCase()} koleksiyonumuz
            </p>
          </div>

          <div className="relative h-[500px] rounded-3xl overflow-hidden mb-16">
            <img
              src={category.image}
              alt={category.name}
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
            <div className="absolute bottom-10 left-10">
              <h2 className="text-4xl font-display font-bold text-white">{category.name}</h2>
            </div>
          </div>

          {categoryProducts.length > 0 && (
            <div className="mb-20">
              <div className="flex items-center justify-between mb-10">
                <div>
                  <p className="text-sm text-warmGray mb-1">KOLEKSİYON</p>
                  <h2 className="text-3xl font-display font-bold text-navy">
                    En Çok Satan Modeller
                  </h2>
                </div>
                <div className="flex items-center gap-2 text-sm text-warmGray">
                  <i className="ri-stack-line text-coral"></i>
                  <span>{categoryProducts.length} model</span>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-product-shop>
                {categoryProducts.map((product) => (
                  <div key={product.id} className="group bg-white rounded-2xl overflow-hidden hover:-translate-y-1 transition-transform duration-300">
                    <div className="relative h-[240px] overflow-hidden bg-[#f9f7f4]">
                      <img
                        src={product.image}
                        alt={product.name}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                      {product.badge && (
                        <div className="absolute top-3 left-3">
                          <span className="px-3 py-1 bg-coral text-white text-xs font-semibold rounded-full whitespace-nowrap">
                            {product.badge}
                          </span>
                        </div>
                      )}
                    </div>

                    <div className="p-5">
                      <h3 className="text-base font-semibold text-navy mb-1 leading-snug">
                        {product.name}
                      </h3>
                      <p className="text-xs text-warmGray mb-4 leading-relaxed">
                        {product.description}
                      </p>

                      <div className="flex items-center justify-between">
                        <div className="flex flex-col">
                          {product.originalPrice && (
                            <span className="text-xs text-warmGray line-through">
                              {product.originalPrice.toLocaleString('tr-TR')} ₺
                            </span>
                          )}
                          <span className="text-lg font-bold text-coral">
                            {product.price.toLocaleString('tr-TR')} ₺
                          </span>
                        </div>
                        <Link
                          to="/iletisim"
                          className="flex items-center gap-1.5 px-4 py-2 bg-navy text-white text-xs font-medium rounded-full hover:bg-coral transition-colors whitespace-nowrap cursor-pointer"
                        >
                          <i className="ri-shopping-bag-line"></i>
                          Teklif Al
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="bg-white rounded-3xl p-12 text-center">
            <div className="w-14 h-14 flex items-center justify-center bg-coral/10 rounded-2xl mx-auto mb-6">
              <i className="ri-customer-service-2-line text-2xl text-coral"></i>
            </div>
            <h3 className="text-2xl font-display font-bold text-navy mb-3">
              Özel Fiyat Teklifi Alın
            </h3>
            <p className="text-warmGray mb-8 max-w-md mx-auto text-sm leading-relaxed">
              Okul veya oyun alanınız için toplu sipariş ve özel ölçü talepleri için bizimle iletişime geçin.
            </p>
            <Link
              to="/iletisim"
              className="inline-flex items-center gap-3 px-8 py-4 bg-coral text-white rounded-full font-medium hover:bg-coral/90 transition-all whitespace-nowrap cursor-pointer"
            >
              Bu Kategori İçin Teklif Al
              <i className="ri-arrow-right-line text-xl"></i>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CategoryPage;
